import ImageWithBody from "../img/ImageWithBody";
import Text from "../Text";
import { getImg } from "../../../../Components/Utils";

const BlogCard = ({ title, description, img, hoverImg, href = "/", category, tall = false }) => {
  return (
    <Text
      is="a"
      href={href}
      className="flex flex-col cursor-pointer h-full group"
      aria-label={title}
    >
      <div className="relative flex-1">
        <ImageWithBody
          src={getImg(img) ?? ""}
          hoverSrc={hoverImg ? getImg(hoverImg) : undefined}
          alt={title}
          objectFit="cover"
          className={`${tall ? "h-full min-h-[420px]" : "aspect-[3/1.2] "} flex items-end`}
        >
          <Text
            is="span"
            variant="btn-white"
            className="m-5 transition-transform duration-300 group-hover:-translate-y-1"
          >
            Read More
          </Text>
        </ImageWithBody>

        {category && (
          <span className="absolute top-3 left-3 bg-white text-gray-800 text-[10px] font-semibold px-2.5 py-1 rounded-full shadow-sm pointer-events-none transition-transform duration-300 group-hover:translate-y-[-2px]">
            {category}
          </span>
        )}
      </div>

      <div className="pt-4 flex flex-col gap-1.5">
        <Text
          is="p"
          variant="card-title"
          className="transition-colors duration-300 group-hover:text-blue-600"
        >
          {title}
        </Text>
        <Text
          is="p"
          variant="body"
          className="line-clamp-2 text-xs leading-4 text-gray-500"
        >
          <div
            className="tiptap-content"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          /></Text>
      </div>
    </Text>
  );
};

export default BlogCard;

